import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const isProduction = process.env.REACT_APP_URL === "https://practido.com/";

const getEnvKey = (keyName) => {
  // 1. Check if unified key is provided
  const unifiedKey = process.env[`REACT_APP_FIREBASE_${keyName}`];
  if (unifiedKey) return unifiedKey;

  // 2. Fallback based on environment selection (Mobile for Production, Web for Dev/Staging)
  const prefix = isProduction ? "REACT_APP_FIREBASE_MOBILE_" : "REACT_APP_FIREBASE_WEB_";
  return process.env[`${prefix}${keyName}`];
};

const firebaseConfig = {
  apiKey: getEnvKey("API_KEY"),
  authDomain: getEnvKey("AUTH_DOMAIN"),
  databaseURL: getEnvKey("DATABASE_URL"),
  projectId: getEnvKey("PROJECT_ID"),
  storageBucket: getEnvKey("STORAGE_BUCKET"),
  messagingSenderId: getEnvKey("MESSAGING_SENDER_ID"),
  appId: getEnvKey("APP_ID"),
  measurementId: getEnvKey("MEASUREMENT_ID"),
};

export const app = initializeApp(firebaseConfig);
export const appMobile = app; // Legacy compatibility alias

export const auth = getAuth(app);
export const authMobile = auth; // Legacy compatibility alias

export const db = getFirestore(app);
export const dbMobile = db; // Legacy compatibility alias

export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export const schoolCollectionRef = collection(db, "schools");
export const parentsCollectionRef = collection(db, "parents");
export const participantsCollectionRef = collection(db, "participants");
export const paymentCollectionRef = collection(db, "payments");
export const questionsCollectionRef = collection(db, "questions");
